// initial state
const state = {
  equipmentsType: [],
  vehiclesType: [],
  alerts: [],
  permissions: [],
  resources: [],
}

// getters
const getters = {
  alerts: (state, getters, rootState) => {
    return state.alerts;
  },
  vehiclesType: (state, getters, rootState) => {
    return state.vehiclesType;
  },
  equipmentsType: (state, getters, rootState) => {
    return state.equipmentsType;
  },
  permissions: (state, getters, rootState) => {
    return state.permissions;
  },
  resources: (state, getters, rootState) => {
    return state.resources;
  },
}

// actions
const actions = {
  destroyStorage({
    state,
    commit,
  }, payload) {
    commit('destroyStorage');
  },
  addAlerts({
    state,
    commit,
  }, payload) {
    commit('addAlerts', {
      alerts: payload.alerts
    });
  },
  setVehiclesType({
    state,
    commit,
  }, payload) {
    commit('setVehiclesType', {
      vehiclesType: payload.vehiclesType
    });
  },
  setEquipmentsType({
    state,
    commit,
  }, payload) {
    commit('setEquipmentsType', {
      equipmentsType: payload.equipmentsType
    });
  },
  setPermissions({
    state,
    commit,
  }, payload) {
    commit('setPermissions', {
      permissions: payload.permissions
    });
  },
  setResources({
    state,
    commit,
  }, payload) {
    commit('setResources', {
      resources: payload.resources
    });
  },
}

// mutations
const mutations = {
  destroyStorage(state) {
    state.alerts = [];
    state.resources = [];
    state.permissions = [];
  },
  addAlerts(state, {
    alerts
  }) {
    state.alerts.push(alerts);
  },
  setVehiclesType(state, {
    vehiclesType
  }) {
    state.vehiclesType = vehiclesType;
  },
  setEquipmentsType(state, {
    equipmentsType
  }) {
    state.equipmentsType = equipmentsType;
  },
  setPermissions(state, {
    permissions
  }) {
    state.permissions = permissions;
  },
  setResources(state, {
    resources
  }) {
    state.resources = resources;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
